/**
 * StaffRestoreReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffRestoreReq
 */
export interface StaffRestoreReq {
  /** 资源ID */
  id: string
}

/**
 * StaffRestoreReq Schema
 */
export const StaffRestoreReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '资源ID',
      format: 'string',
      type: 'string',
      label: '资源ID',
    },
  },
  required: ['id'],
  type: 'object',
}
